<template>
  <div id="addevaluatorsMain">
    <div class="row">
      <div class="col-8">
        <page-header :page="page" />
      </div>
      <div class="col-4">
        <div class="d-flex justify-content-end">
          <action-button
            i="fas fa-arrow-circle-left"
            variant="success m-2"
            @click="goBack"
          >
            Regresar
          </action-button>
          <action-button
            v-if="
              previewListProposalAssignedToEvaluators.length > 0 &&
                canBeAssignedToEvaluators
            "
            i="fas fa-chevron-circle-right"
            variant="success m-2"
            @click="assignProposalsToEvaluatorsHandler"
          >
            Continuar
          </action-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <custom-separator :text="page.separatorTitle" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <custom-callout
          v-for="(item, index) in previewListProposalAssignedToEvaluators"
          :key="index"
          class="mt-2"
          :has-toggle="false"
        >
          <div class="row">
            <div class="col-12 pl-5">
              <div class="divider-horizontal">
                <div class="row">
                  <div class="col-2 custom-information-container">
                    <div class="custom-information-icon">
                      <i class="orange-icon fas fa-user-tie" />
                    </div>
                    <div class="regular custom-information-title">Nombre:</div>
                    <div
                      class="regular custom-information"
                      style="text-transform: capitalize"
                    >
                      <b>{{ item.evaluatorName.toLowerCase() }}</b>
                    </div>
                  </div>
                  <div class="col-4">
                    <custom-information
                      :news="item.educ_New"
                      :renovation="item.educ_Renew"
                      :title="'Servicios Educativos'"
                    />
                  </div>
                  <div class="col-4">
                    <custom-information
                      :news="item.serv_Relat_New"
                      :renovation="item.serv_Relat_Renew"
                      :title="'Servicios Relacionados'"
                    />
                  </div>
                  <div class="col-2">
                    <div class="regular custom-information-total">
                      <p>Total:</p>
                      <p class="quantity">
                        {{ item.total_Proposals }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomCallout from 'custom-callout';
import CustomInformation from './components/CustomInformation';
import PageHeader from 'PageHeader';
import store from '@/store';
import {
  assignProposalsToEvaluators,
  getpreviewProposalsAssignedToEvaluators,
  proposalsCanBeAssignedToEvaluators,
} from '@/modules/serviceProposalHistory/api';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'AddEvaluators',
  components: {
    PageHeader,
    ActionButton,
    CustomSeparator,
    CustomCallout,
    CustomInformation,
  },
  mixins: [alertMixin],
  data() {
    return {
      sie: store.state.studentId,
      previewListProposalAssignedToEvaluators: [],
      canBeAssignedToEvaluators: false,
      page: {
        icon: 'fas fa-user-tie',
        title: 'Asignación de Evaluadores',
        routes: [
          'Proveedor',
          'Propuesta de servicios',
          'Asignación de Evaluadores',
        ],
        separatorTitle:
          'Vista previa del resultado de Asignación  de Evaluaciones',
      },
    };
  },
  async mounted() {
    await getpreviewProposalsAssignedToEvaluators().then((res) => {
      this.previewListProposalAssignedToEvaluators = res.data;
    });
    await this.canAssignProposal();
  },
  methods: {
    async canAssignProposal() {
      await proposalsCanBeAssignedToEvaluators().then((res) => {
        this.canBeAssignedToEvaluators = res.data;
      });
    },
    goBack() {
      this.$router.push({
        name: 'ServiceProposalHistory',
        params: {
          reload: true,
        },
      });
    },
    async assignProposalsToEvaluatorsHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmar',
        '¿Desea continuar con el proceso de asignación a evaluadores?',
        'Si',
        'No'
      );
      if (!answer) {
        return;
      }
      this.canBeAssignedToEvaluators = false; //To Trying to don't re-asign multiples evaluators
      await assignProposalsToEvaluators()
        .then(async (response) => {
          if (response.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'El proceso de Asignacion ha sido completado exitosamente.',
              'success'
            );
          }
        })
        .catch((err) => {
          if (err.response != undefined)
            this.ShowToast('Error', err.response.data.errors.errors[0]);
          else this.ShowToast('Error', err);
        });
      //Validate if can Assign Proposal
      await this.canAssignProposal();
    },
  },
};
</script>

<style scoped>
.custom-separator-title {
  margin-top: 50px;
}

.custom-information b {
  color: #000;
}

.custom-information-container {
  padding: 0px 0px 30px 0px;
  border-right: #e8e8e8;
  border-right-style: solid;
  border-right-width: 2px;
}

.custom-information-title {
  margin-top: 15px;
}

.custom-information-icon {
  float: left;
  margin-right: 20px;
  margin-top: 30px;
}

.custom-information-total p {
  text-align: center;
}

.custom-information-total .quantity {
  background-color: #b5c3bc;
  border-radius: 15px;
  padding: 5px 5px 5px 5px;
  width: 60px;
  position: relative;
  display: block;
  margin: 0 auto;
  color: #fff;
}

.orange-icon {
  color: #ff7058;
  font-size: 21pt;
  padding-right: 4px;
  line-height: 25px;
  margin-left: 4px;
}

.col-2,
.col-4 {
  padding: 0px !important;
}

@media (max-width: 1024px) {
  #addevaluatorsMain {
    float: left;
    width: 95%;
  }

  .custom-information-icon {
    margin-right: 5px;
  }

  .custom-information-title {
    font-size: 14px;
  }

  .custom-information b {
    font-size: 15px;
  }

  .orange-icon {
    font-size: 23px;
  }

  .pl-5 {
    padding-left: 25px !important;
  }
}

@media (max-width: 1366px) {
  #addevaluatorsMain {
    float: left;
    width: 100%;
  }
}
</style>
